/** Attribution stamped on a 401 by whichever layer minted it. */
export const API_401_HEADER = {
  ORIGIN: 'x-api-401-origin',
  REFRESH: 'x-api-401-refresh',
  DENIAL_CODE: 'x-api-401-denial-code',
} as const;

/**
 * Clerk's `withDebugHeaders` output. `clerkMiddleware` copies
 * every `requestState.headers` entry onto the handler result,
 * so these ride any response the middleware touches — not
 * only the 401 it mints.
 * Docs:
 *   https://clerk.com/docs/reference/nextjs/clerk-middleware
 */
export const CLERK_AUTH_HEADER = {
  REASON: 'x-clerk-auth-reason',
  STATUS: 'x-clerk-auth-status',
} as const;

export const API_401_ATTR = {
  ORIGIN: 'api_401.origin',
  REASON: 'api_401.reason',
  STATUS: 'api_401.status',
  HAS_REFRESH_COOKIE: 'api_401.has_refresh_cookie',
  ROUTE_GROUP: 'api_401.route_group',
  DENIAL_CODE: 'api_401.denial_code',
} as const;

export const API_401_SPAN = {
  NAME: 'api.401',
  OP: 'auth.401',
} as const;

/**
 * Layers that stamp their own origin. Anything else reaching
 * the client 401s as `unknown` — an uninstrumented mint site,
 * which the triage runbook surfaces rather than drops.
 */
export const API_401_MINT_ORIGINS = ['middleware', 'route'] as const;

export type Api401MintOrigin = (typeof API_401_MINT_ORIGINS)[number];
